(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner_2"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hero-carousel')) {
  class HeroCarousel extends HTMLElement {
    constructor() {
      super();
      this.slides = Array.from(this.querySelectorAll('.hero-carousel__slide'));
      this.prevButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      this.discountTab = this.querySelector('[data-discount-tab]');

      this.currentIndex = 0;
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 7000;
      this.autoplayTimer = null;
      this.userInteracted = false;
    }

    connectedCallback() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.onManualNavigate(this.currentIndex - 1));
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.onManualNavigate(this.currentIndex + 1));
      }

      if (this.discountTab) {
        const klaviyoFormId = this.discountTab.dataset.klaviyoFormId;
        this.discountTab.addEventListener('click', () => {
          if (!klaviyoFormId) return;
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', klaviyoFormId]);
        });
      }

      this.slides.forEach((slide) => {
        const linkTarget = slide.dataset.slideLink;
        if (!linkTarget) return;
        slide.style.cursor = 'pointer';
        slide.addEventListener('click', (event) => {
          if (event.target.closest('a, button')) return;
          window.location.href = linkTarget;
        });
      });

      this.goToSlide(0);
      this.startAutoplay();

      this.handleSectionLoad = (event) => {
        if (event.target.contains(this)) this.reset();
      };
      this.handleBlockSelect = (event) => {
        const slide = event.target.closest('.hero-carousel__slide');
        if (!slide || !this.contains(slide)) return;
        this.pauseAutoplay();
        this.goToSlide(this.slides.indexOf(slide));
      };
      this.handleBlockDeselect = (event) => {
        const slide = event.target.closest('.hero-carousel__slide');
        if (!slide || !this.contains(slide)) return;
        this.startAutoplay();
      };

      document.addEventListener('shopify:section:load', this.handleSectionLoad);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
      document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);
    }

    disconnectedCallback() {
      this.pauseAutoplay();
      document.removeEventListener('shopify:section:load', this.handleSectionLoad);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
    }

    reset() {
      this.pauseAutoplay();
      this.userInteracted = false;
      this.goToSlide(0);
      this.startAutoplay();
    }

    goToSlide(index) {
      if (!this.slides.length) return;
      const total = this.slides.length;
      this.currentIndex = (index + total) % total;

      this.slides.forEach((slide, i) => {
        const isActive = i === this.currentIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    }

    onManualNavigate(index) {
      this.userInteracted = true;
      this.pauseAutoplay();
      this.goToSlide(index);
    }

    startAutoplay() {
      if (!this.autoplayEnabled || this.userInteracted || this.slides.length < 2) return;
      this.pauseAutoplay();
      this.autoplayTimer = window.setInterval(() => {
        this.goToSlide(this.currentIndex + 1);
      }, this.autoplaySpeed);
    }

    pauseAutoplay() {
      if (this.autoplayTimer) {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

  }

  customElements.define('hero-carousel', HeroCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Search focus/blur — lightweight delegation
  document.addEventListener('DOMContentLoaded', function() {
    var body = document.body;
    var blurTimer = null;

    // Event delegation no header — evita múltiplos listeners
    var header = document.querySelector('.section-header');
    if (!header) return;

    header.addEventListener('focusin', function(e) {
      if (e.target.matches('.search__input, .predictive-search__input, input[type="search"]')) {
        if (blurTimer) { clearTimeout(blurTimer); blurTimer = null; }
        body.classList.add('search-active');
      }
    }, { passive: true });

    header.addEventListener('focusout', function(e) {
      if (e.target.matches('.search__input, .predictive-search__input, input[type="search"]')) {
        blurTimer = setTimeout(function() {
          body.classList.remove('search-active');
        }, 150);
      }
    }, { passive: true });

    // Click fora para fechar
    document.addEventListener('click', function(e) {
      if (!body.classList.contains('search-active')) return;
      if (!e.target.closest('.header__search, .search-modal, details-modal, .predictive-search__results-groups-wrapper')) {
        body.classList.remove('search-active');
      }
    });
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this._ticking = false;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (this._ticking) return;
      this._ticking = true;
      requestAnimationFrame(() => {
        this._handleScroll();
        this._ticking = false;
      });
    }

    _handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
